import React, { createContext, useContext, ReactNode } from 'react'
import { FlatInteractionModelData, InteractionModel } from 'types/shared'

interface ReviewContextData {
  flatData: FlatInteractionModelData | undefined
  user: string
  dateStartInteraction: string
  geolocation: InteractionModel['geolocation']
  reviewActivity?: boolean
  displayedActivityModels?: string[]
}

interface ReviewContextProviderProps {
  children: ReactNode
  value: ReviewContextData
}

const ReviewContext = createContext<ReviewContextData | undefined>(undefined)

export const ReviewContextProvider = ({
  children,
  value
}: ReviewContextProviderProps) => {
  return (
    <ReviewContext.Provider value={value}>{children}</ReviewContext.Provider>
  )
}

export const useReviewContext = () => {
  const context = useContext(ReviewContext)
  if (context === undefined) {
    throw new Error(
      'useReviewContext must be used within a ReviewContextProvider'
    )
  }
  return context
}
